import { collection, getDocs, onSnapshot, orderBy, query, where } from "firebase/firestore"
import { complexRefv9 } from "src/services/complexServices"

const accountsRef = (id) => collection(complexRefv9(id), 'cuentas')

export const getAccounts = async (id) => {
  try {
    const snap = await getDocs(query(accountsRef(id), orderBy('TipoMetodo', 'desc')))
    const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    return data
  } catch (error) {
    throw Error(error)
  }
}
export const suscriberBankAccounts = (id, observer) => onSnapshot(query(
  accountsRef(id),
  where('TipoMetodo', 'in', ['Cuenta Bancaria', 'Cuenta BancariaOculta']),
  orderBy('TipoMetodo', 'desc')), observer)